export interface AttachmentType {
  id: any;
  size: any;
  mime_type: any;
  extension: any;
  filename: any;
  url: any;
}

export enum ActionStatusType {
  NOT_START = 'not_start',
  RUNNING = 'running',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export interface ActionType {
  id: any;
  status: ActionStatusType;
  attachment: AttachmentType[];
  created_at: any;
  updated_at: any;
}